import { Component, LOCALE_ID, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }],
})
export class AppComponent implements OnInit {
  title = environment.appTitle;

  ngOnInit(): void {
    document.documentElement.style.setProperty('--app-background-color', environment.backgroundColor);
    document.documentElement.style.setProperty('--app-contrast-text-color', environment.contrastTextColor);
    document.documentElement.style.setProperty('--app-header-texts-color', environment.headerTextColor);
    document.documentElement.style.setProperty('--app-accent-color', environment.accentColor);
    document.documentElement.style.setProperty('--app-tables-hover-color', environment.hoverTableColor);
    document.documentElement.style.setProperty('--app-primary-color', environment.primaryColor);
  }

  constructor(
    private readonly titleService: Title,
    private readonly renderer: Renderer2
  ) {
    this.setTitle();
    this.setFavicon(environment.favicon);
    registerLocaleData(localeEs, 'es-ES');
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement = this.renderer.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;

    const existingLink = document.querySelector("link[rel~='icon']");
    if (existingLink) {
      document.head.removeChild(existingLink);
    }

    document.head.appendChild(link);
  }

  private setTitle() {
    this.titleService.setTitle(this.title);
  }
}
